export const AUTH_EXPIRED_EVENT = 'lk-meet-auth-expired';

export type AuthExpiredDetail = {
  redirect: boolean;
};

export function notifyAuthExpired(options?: { redirect?: boolean }) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<AuthExpiredDetail>(AUTH_EXPIRED_EVENT, {
      detail: { redirect: options?.redirect ?? false },
    }),
  );
}
